// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__5dLxO","number":"NotFound_number__GHu8e","text":"NotFound_text__lhNuC","header":"NotFound_header__JzHTq"};